import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import { MInput } from '../../Input/index';
import '../../../assets/styles/global.scss';
import '../styles/searchBar.scss';
function SearchColor(props) {
    const [color, setColor] = useState(null);
    const [enableBtn, setEnableBtn] = useState(true);
    const { parrentState, show } = props;
    
    useEffect(() => {
        if (parrentState !== color) setColor(parrentState)
        return () => setColor(null);
    }, [parrentState]);

    useEffect(() => {
        setColor(parrentState)
    }, [show]);

    useEffect(() => {
        if (color)
            setEnableBtn(false);
        else
            setEnableBtn(true);
    }, [color]);

    const handleChange = obj => {
        setColor(obj)
    }

    return (
        <>
            {show && (
                <>
                    <div className="search-bar-input-section">
                        <MInput label="Color" fullWidth={true} value={color} handleChange={event => handleChange(event.target.value)} />
                    </div>
                    <div className="button-section">
                        <Button className="button-grey m-r-12" onClick={() => {
                            if (props.parrentState) {
                                setColor(null)
                                props.setParent('color', null);

                            };
                            props.closeFilter();
                        }}>Clear</Button>
                        <Button className="button-green" disabled={enableBtn} onClick={() => {
                            props.setParent('color', color);
                            props.closeFilter();
                        }} >Apply</Button>
                    </div>
                </>
            )}
        </>
    );
}

export default SearchColor;